/* FanMoment seven-step customizer: multiple originals, subject count and inline review. */
(() => {
  if (window.FanMomentSevenStep) { window.FanMomentSevenStep.mount(document); return; }
  async function initialize(root) {
    if (root.dataset.ready || !root.querySelector("[data-product]")) return;
    root.dataset.ready = "true";
  const $ = (s) => root.querySelector(s), $$ = (s) => [...root.querySelectorAll(s)];
  const product = JSON.parse($('[data-product]').textContent);
  const meta = JSON.parse($('[data-variant-meta]').textContent);
  const lifecycle = new AbortController();
  const stepGroup = $('[data-step-group]'), footer = $('.fm-builder__footer');
  // Reserve space after the global footer, not only inside the builder.
  // Each mounted section owns its spacer so editor unload restores the page.
  const pageFooter = document.querySelector('.footer-group');
  const pageEndSpacer = document.createElement('div');
  pageEndSpacer.className = 'fm-builder__page-end-spacer';
  pageEndSpacer.setAttribute('aria-hidden', 'true');
  pageFooter?.append(pageEndSpacer);
  function measureFooter() {
    const height = Math.ceil(footer.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty('--fm-footer-height', height + 'px');
      pageEndSpacer.style.setProperty('--fm-footer-height', height + 'px');
    }
  }
  footer.prepend(stepGroup);
  const footerObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(measureFooter) : null;
  footerObserver?.observe(footer);
  lifecycle.signal.addEventListener('abort', () => {
    footerObserver?.disconnect();
    pageEndSpacer.remove();
  });
  measureFooter();
  root.fmDestroy = () => { lifecycle.abort(); delete root.dataset.ready; };
  // Liquid exposes only a subset on high-variant products. Fetch the public catalog,
  // with country context, without embedding any Admin or Storefront access token.
  if (Number(root.dataset.variantCount) > product.variants.length) {
    const controls = new Map([...root.querySelectorAll('button,input,textarea')].map(el => [el, el.disabled]));
    controls.forEach((_, el) => { el.disabled = true; }); root.setAttribute('aria-busy', 'true');
    $('[data-step-status]').textContent = 'Loading available sizes and frames…';
    try {
      const nodes = [], cursors = new Set(); let after = null, more = true;
      const query = 'query($handle:String!,$after:String,$country:CountryCode) @inContext(country:$country) { product(handle:$handle) { id variants(first:100,after:$after) { nodes { id title availableForSale selectedOptions { name value } price { amount currencyCode } } pageInfo { hasNextPage endCursor } } } }';
      while (more) {
        const response = await fetch('/api/2026-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: lifecycle.signal, body: JSON.stringify({ query, variables: { handle: product.handle, after, country: root.dataset.country || null } }) });
        if (!response.ok) throw new Error('Catalog request failed.');
        const result = await response.json(), item = result.data?.product;
        if (result.errors?.length || !item || item.id !== 'gid://shopify/Product/' + product.id) throw new Error('Catalog could not be verified.');
        nodes.push(...item.variants.nodes); more = item.variants.pageInfo.hasNextPage; after = item.variants.pageInfo.endCursor;
        if (more && (!after || cursors.has(after) || nodes.length > 2048)) throw new Error('Incomplete catalog response.');
        cursors.add(after);
      }
      if (!nodes.length || nodes.some(v => v.price.currencyCode !== root.dataset.currency)) throw new Error('Unable to verify prices in your currency.');
      const names = product.options.map(option => option.name || option);
      product.variants = nodes.map(v => ({ id: Number(v.id.split('/').pop()), title: v.title, available: v.availableForSale, price: Number(v.price.amount) * 100, options: names.map(name => v.selectedOptions.find(o => o.name === name)?.value) }));
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency });
      meta.splice(0, meta.length, ...nodes.map(v => ({ id: Number(v.id.split('/').pop()), price: money.format(Number(v.price.amount)) + ' ' + v.price.currencyCode })));
    } catch (err) {
      if (!lifecycle.signal.aborted) {
        $('[data-error]').hidden = false; $('[data-error]').textContent = 'Sizes and prices could not be loaded. Please reload this page before ordering.';
        $('[data-step-status]').textContent = 'Catalog unavailable';
      }
      root.removeAttribute('aria-busy'); return;
    }
    if (lifecycle.signal.aborted || !root.isConnected) return;
    controls.forEach((value, el) => { el.disabled = value; }); root.removeAttribute('aria-busy');
  }
  const state = {step:1,busy:false,transitioning:false,email:'',artworkText:'',artworkPosition:'',photos:[],imageLoading:false,subjects:1,notes:'',style:null,styleId:null,size:null,frame:null,frameGroup:null,variant:null};
  const error = $('[data-error]'), fileInput = $('[data-file]');
  const panels = new Map($$('[data-step-panel]').map(panel => [Number(panel.dataset.stepPanel), panel]));
  const anchors = new Map();
  const photoHeading = panels.get(2).querySelector('h2').textContent;
  let scrollVersion = 0;
  function scrollToEditor() {
    const version = ++scrollVersion;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (version !== scrollVersion || !editing || lifecycle.signal.aborted) return;
      const editor = $('[data-review-editor]');
      editor.querySelector('h2')?.focus({preventScroll:true});
      (editTrigger?.closest('.fm-builder__review-summary dl > div') || editTrigger || editor).scrollIntoView({block:'start',behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
  }
  panels.forEach((panel, n) => { const anchor = document.createComment('builder-step-' + n); panel.before(anchor); anchors.set(n, anchor); });
  const optionNames = (product.options || []).map(option => String(option.name || option));
  const findOption = terms => optionNames.findIndex(name => terms.some(term => name.toLowerCase().includes(term)));
  const sizeIndex = findOption(['size']), frameIndex = findOption(['frame']), subjectIndex = findOption(['subject','people','person']);
  function setError(message) { error.textContent = message; error.hidden = !message; }
  if ([sizeIndex, frameIndex, subjectIndex].some(index => index < 0)) {
    setError('This product needs Size, Frame and Subjects options. Please contact us for help.');
    root.querySelectorAll('button,input,textarea').forEach(el => { el.disabled = true; }); return;
  }
  const rolled = 'Rolled Canvas';
  const frameAllowed = value => value === rolled || /^Stretch\+(Black|Gold|Silver|White|Wood) Frame$/.test(value);
  const catalog = product.variants.filter(v => frameAllowed(v.options[frameIndex]));
  const subjectValues = [...new Set(catalog.filter(v => v.available).map(v => Number.parseInt(v.options[subjectIndex], 10)))].filter(Number.isFinite).sort((a,b) => a-b);
  const maxSubjects = Math.max(1, ...subjectValues);
  $('[data-subjects]').max = String(maxSubjects);
  let addedFingerprint = null, addedKey = null, uncertain = false, editing = null, editTrigger = null, editSnapshot = null;
  const errorAnchor = document.createComment('builder-error'); error.before(errorAnchor);
  const textPositions = new Map([['bottom-right','Bottom right'],['bottom-left','Bottom left'],['top-center','Top center'],['bottom-center','Bottom center']]);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency});
  const amount = cents => money.format(Number(cents) / 100);
  const priceLabel = variant => variant ? meta.find(m => String(m.id) === String(variant.id))?.price || amount(variant.price) : '—';
  const availableVariants = () => catalog.filter(v => v.available && Number.parseInt(v.options[subjectIndex],10) === state.subjects);
  const allSizes = [...new Set(catalog.map(v => v.options[sizeIndex]))];
  const allFrames = [...new Set(catalog.map(v => v.options[frameIndex]))].filter(value => value !== rolled);
  const styles = $$('[data-style-thumbs] [data-style]').map(button => ({id:button.dataset.styleId,name:button.dataset.style}));
  const normalizeSize = value => String(value).toLowerCase().replace(/×/g,'x').replace(/\s/g,'');
  function refreshReview() {
    if (state.step !== 7) return;
    const values = {subjects:Number.isInteger(state.subjects) ? state.subjects : 'Choose a count',style:state.style || '—',size:state.size || 'Choose a size',frame:state.frame || 'Choose a frame',email:state.email,notes:state.notes.trim() || 'None',text:state.artworkText.trim() || 'None',price:priceLabel(state.variant)};
    Object.entries(values).forEach(([key,value]) => { $('[data-review-' + key + ']').textContent = value; });
    const positionRow = $('[data-review-position-row]');
    positionRow.hidden = !state.artworkText.trim() && !positionRow.contains($('[data-review-editor]'));
    $('[data-review-position]').textContent = textPositions.get(state.artworkPosition) || 'Choose a position';
  }
  function photoFigure(photo, index, removable) {
    const figure = document.createElement('figure'), img = document.createElement('img'), caption = document.createElement('figcaption');
    img.src = photo.url; img.alt = 'Uploaded photo ' + (index + 1); img.width = 400; img.height = 400;
    const name = document.createElement('span'); name.textContent = (index + 1) + '. ' + photo.file.name;
    caption.append(name);
    if (removable) {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Remove';
      button.setAttribute('aria-label','Remove photo ' + (index + 1)); button.disabled = state.imageLoading;
      button.addEventListener('click', () => {
        if (state.busy || state.imageLoading || uncertain) return;
        state.photos.splice(state.photos.indexOf(photo),1);
        if (!editSnapshot?.photos.includes(photo)) URL.revokeObjectURL(photo.url);
        renderPhotos(); setError('');
        const nextButton = $('[data-upload-gallery] button'); (nextButton || fileInput).focus({preventScroll:true});
      });
      caption.append(button);
    }
    figure.append(img);
    if (removable) figure.append(caption);
    return figure;
  }
  function renderPhotos() {
    $('[data-upload-gallery]').replaceChildren(...state.photos.map((photo,i) => photoFigure(photo,i,true)));
    $('[data-review-gallery]').replaceChildren(...state.photos.map((photo,i) => photoFigure(photo,i,false)));
    $('[data-photo-count]').textContent = state.imageLoading ? 'Opening your photos…' : state.photos.length + ' of 10 photos added';
    fileInput.disabled = state.imageLoading || state.photos.length >= 10 || state.busy || uncertain;
    $('[data-upload-title]').textContent = state.photos.length >= 10 ? '10 photos added — remove one to add another' : 'Add your photos';
    refreshReview();
  }
  function openImage(file) {
    return new Promise((resolve,reject) => {
      const url = URL.createObjectURL(file), img = new Image();
      let finished = false;
      const abort = () => finish(false);
      const timer = setTimeout(() => finish(false), 20000);
      function finish(ok) {
        if (finished) return; finished = true; clearTimeout(timer);
        lifecycle.signal.removeEventListener('abort',abort); img.onload = img.onerror = null;
        if (ok) resolve({file,url}); else { URL.revokeObjectURL(url); reject(new Error('Could not open ' + file.name + '. Please choose a valid image.')); }
      }
      lifecycle.signal.addEventListener('abort',abort,{once:true});
      img.onload = () => finish(img.naturalWidth > 0 && img.naturalHeight > 0);
      img.onerror = () => finish(false); img.src = url;
    });
  }
  async function addPhotos(files) {
    if (state.busy || state.imageLoading || uncertain || !files.length) return;
    if (state.photos.length + files.length > 10) { setError('You can add up to 10 photos. Remove a photo or choose fewer files.'); return; }
    const bad = files.find(file => !/^image\/(jpeg|png|webp)$/i.test(file.type) || !file.size || file.size > Number(root.dataset.maxMb) * 1024 * 1024);
    if (bad) { setError('Each photo must be a valid JPG, PNG or WEBP, ' + root.dataset.maxMb + 'MB or smaller. No files from this selection were added.'); return; }
    state.imageLoading = true; renderPhotos(); setError('');
    const pending = [];
    try {
      for (const file of files) {
        pending.push(await openImage(file));
        if (lifecycle.signal.aborted || !root.isConnected) throw new Error('Upload cancelled.');
      }
      state.photos.push(...pending);
    } catch (err) {
      pending.forEach(photo => URL.revokeObjectURL(photo.url));
      if (!lifecycle.signal.aborted) setError(err.message);
    } finally {
      state.imageLoading = false;
      if (!lifecycle.signal.aborted) renderPhotos();
    }
  }
  fileInput.addEventListener('change', () => { const files = [...fileInput.files]; fileInput.value = ''; addPhotos(files); });
  lifecycle.signal.addEventListener('abort', () => {
    state.photos.forEach(photo => URL.revokeObjectURL(photo.url));
    if (editing) restoreEditor();
    anchors.forEach(anchor => anchor.remove());
  });
  function selectStyle(id) {
    const style = styles.find(item => item.id === id); if (!style) return;
    state.styleId = style.id; state.style = style.name;
    $$('[data-style-id]').forEach(button => { const selected = button.dataset.styleId === id; button.classList.toggle('is-selected',selected); button.setAttribute('aria-pressed',String(selected)); });
    refreshReview();
  }
  $$('[data-style-id]').forEach(button => button.addEventListener('click', () => { selectStyle(button.dataset.styleId); setError(''); }));
  selectStyle(styles[0]?.id);
  function syncTextPosition() {
    const hasText = !!state.artworkText.trim(), group = $('[data-text-position-group]');
    group.hidden = !hasText; group.disabled = !hasText;
    if (!hasText) state.artworkPosition = '';
    $$('[data-text-position]').forEach(input => { input.checked = hasText && input.value === state.artworkPosition; input.required = hasText; });
    refreshReview();
  }
  $('[data-notes]').addEventListener('input', event => { state.notes = event.target.value; $('[data-notes-count]').textContent = state.notes.length; refreshReview(); });
  $('[data-artwork-text]').addEventListener('input', event => { state.artworkText = event.target.value; syncTextPosition(); });
  $$('[data-text-position]').forEach(input => input.addEventListener('change', () => { if (input.checked && state.artworkText.trim() && textPositions.has(input.value)) { state.artworkPosition = input.value; setError(''); refreshReview(); } }));
  $('[data-email]').addEventListener('input', event => { state.email = event.target.value.trim(); refreshReview(); });
  function changeCount(value) {
    state.subjects = value; refreshAvailability(); setError('');
    $('[data-subject-status]').textContent = subjectValues.includes(value) ? value + ' subject' + (value === 1 ? '' : 's') + ' in the finished painting. The price is based on this number, not the number of photos.' : 'Choose an available whole number from 1 to ' + maxSubjects + '.';
    $('[data-count-minus]').disabled = !(value > 1);
    $('[data-count-plus]').disabled = !(value < maxSubjects);
  }
  $('[data-subjects]').addEventListener('input', event => changeCount(event.target.value === '' ? NaN : Number(event.target.value)));
  $$('[data-count-minus],[data-count-plus]').forEach(button => button.addEventListener('click', () => {
    const value = Math.min(maxSubjects,Math.max(1,(Number.isInteger(state.subjects) ? state.subjects : 1) + (button.hasAttribute('data-count-plus') ? 1 : -1)));
    $('[data-subjects]').value = String(value); changeCount(value);
  }));
  function optionButton(value, subtitle, selected, enabled, onSelect) {
    const button = document.createElement('button'); button.type = 'button'; button.dataset.value = value; button.disabled = !enabled;
    button.classList.toggle('is-selected',selected); button.setAttribute('aria-pressed',String(selected));
    const label = document.createElement('strong'), detail = document.createElement('small');
    label.textContent = value; detail.textContent = enabled ? subtitle : 'Unavailable'; button.append(label,detail);
    button.addEventListener('click', onSelect); return button;
  }
  function focusOption(container,value) { [...container.querySelectorAll('button[data-value]')].find(button => button.dataset.value === value)?.focus({preventScroll:true}); }
  function decorateFrame(button, value) {
    const normalize = text => String(text).toLowerCase().replace(/\s+/g,'');
    const sources = $$('[data-frame-guide]').filter(el => normalize(el.dataset.frameGuide) === normalize(value));
    const sourceImage = sources.find(el => el.querySelector('img'))?.querySelector('img');
    const description = sources.map(el => el.querySelector('[data-frame-description]')?.textContent.trim()).find(Boolean);
    if (sourceImage) {
      const image = sourceImage.cloneNode(true);
      image.alt = ''; image.className = 'fm-builder__frame-image';
      button.classList.add('fm-builder__frame-card'); button.prepend(image);
    }
    if (description) {
      const text = document.createElement('span'); text.className = 'fm-builder__frame-description'; text.textContent = description;
      button.querySelector('strong').after(text);
    }
    return button;
  }
  function sizeGuide(size) {
    const guide = document.createElement('div'); guide.className = 'fm-builder__size-guide';
    const matches = $$('[data-size-guide]').filter(el => normalizeSize(el.dataset.sizeGuide) === normalizeSize(size));
    const custom = matches.find(el => el.querySelector('img')) || matches[0];
    if (custom?.querySelector('img')) guide.append(custom.querySelector('img').cloneNode(true));
    else {
      const dimensions = size.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      const scene = document.createElement('div'); scene.className = 'fm-builder__scale-scene'; scene.setAttribute('aria-label','Approximate size illustration for ' + size); scene.setAttribute('role','img');
      const art = document.createElement('span'); art.className = 'fm-builder__scale-art'; art.textContent = size;
      if (dimensions) {
        art.style.width = Math.min(85,Math.max(10,Number(dimensions[1]) / 84 * 100)) + '%';
        art.style.aspectRatio = dimensions[1] + ' / ' + dimensions[2];
      }
      scene.append(art); guide.append(scene);
      const caption = document.createElement('small'); caption.textContent = 'Proportion guide only; measure your space before ordering.'; guide.append(caption);
    }
    const description = custom?.querySelector('.rte');
    if (description?.textContent.trim()) guide.append(description.cloneNode(true));
    else { const text = document.createElement('p'); text.textContent = size + ' canvas. Choose a size that suits your space and composition.'; guide.append(text); }
    return guide;
  }
  function frameExtra(variant,base) {
    if (!variant) return 'Unavailable';
    if (!base) return 'Artwork total ' + priceLabel(variant);
    const delta = Math.round(Number(variant.price) - Number(base.price));
    return delta === 0 ? 'FREE · No extra charge' : (delta > 0 ? '+' : '−') + amount(Math.abs(delta));
  }
  function refreshAvailability() {
    const variants = availableVariants();
    const sizes = [...new Set(variants.map(v => v.options[sizeIndex]))];
    if (!sizes.includes(state.size)) { state.size = null; state.frame = null; state.frameGroup = null; }
    const current = variants.filter(v => v.options[sizeIndex] === state.size);
    const base = current.find(v => v.options[frameIndex] === rolled);
    const framed = current.filter(v => v.options[frameIndex] !== rolled).sort((a,b) => a.price-b.price);
    if (!current.some(v => v.options[frameIndex] === state.frame)) state.frame = null;
    if (state.frameGroup === 'rolled') state.frame = base ? rolled : null;
    if (state.frameGroup === 'framed' && state.frame === rolled) state.frame = null;
    const sizeContainer = $('[data-sizes]'); sizeContainer.replaceChildren();
    let expandedGuide = null;
    allSizes.filter(size => sizes.includes(size)).forEach((size,index) => {
      const candidates = variants.filter(v => v.options[sizeIndex] === size).sort((a,b) => a.price-b.price);
      const wrapper = document.createElement('div'); wrapper.className = 'fm-builder__size-option';
      const selected = state.size === size;
      const button = optionButton(size,'From ' + priceLabel(candidates[0]),selected,sizes.includes(size),() => {
        if (state.size !== size) { state.size = size; state.frame = null; state.frameGroup = null; }
        refreshAvailability(); setError(''); focusOption(sizeContainer,size);
      });
      const id = 'FmSizeGuide-' + root.closest('[id]')?.id + '-' + index;
      button.setAttribute('aria-expanded',String(selected)); button.setAttribute('aria-controls',id);
      const detail = selected ? sizeGuide(size) : document.createElement('div'); detail.id = id; detail.hidden = !selected;
      if (selected) expandedGuide = { detail, row: Math.floor(index / 2) + 2 };
      else wrapper.append(detail);
      wrapper.prepend(button); sizeContainer.append(wrapper);
    });
    if (expandedGuide) {
      expandedGuide.detail.style.gridRow = String(expandedGuide.row);
      sizeContainer.append(expandedGuide.detail);
    }
    const groups = $('[data-frame-groups]'); groups.replaceChildren();
    const rolledButton = optionButton('Rolled Canvas',frameExtra(base,base),state.frameGroup === 'rolled',!!base,() => { state.frameGroup = 'rolled'; state.frame = rolled; refreshAvailability(); setError(''); focusOption(groups,'Rolled Canvas'); });
    const framedButton = optionButton('Framed',framed.length ? (framed.length > 1 && framed.some(v => v.price !== framed[0].price) ? 'From ' : '') + frameExtra(framed[0],base) : '',state.frameGroup === 'framed',!!framed.length,() => { state.frameGroup = 'framed'; if (state.frame === rolled) state.frame = null; refreshAvailability(); setError(''); focusOption(groups,'Framed'); });
    framedButton.setAttribute('aria-expanded',String(state.frameGroup === 'framed'));
    groups.append(decorateFrame(rolledButton,'Rolled Canvas'),decorateFrame(framedButton,'Framed'));
    $('[data-frame-finishes]').hidden = state.frameGroup !== 'framed';
    const finishes = $('[data-frames]'); finishes.replaceChildren();
    allFrames.forEach(frame => {
      const variant = framed.find(v => v.options[frameIndex] === frame);
      finishes.append(decorateFrame(optionButton(frame,frameExtra(variant,base),state.frame === frame,!!variant,() => { state.frame = frame; state.frameGroup = 'framed'; refreshAvailability(); setError(''); focusOption(finishes,frame); }),frame));
    });
    $('[data-size-note]').textContent = (Number.isInteger(state.subjects) ? state.subjects : '—') + ' subjects · ' + sizes.length + ' available sizes. Unsupported combinations cannot be selected.';
    state.variant = current.find(v => v.options[frameIndex] === state.frame) || null;
    $('[data-variant-title]').textContent = state.variant?.title || 'Choose a size and frame';
    $('[data-price]').textContent = priceLabel(state.variant); refreshReview();
  }
  function validateStep(step) {
    if (step === 1 && !state.styleId) return 'Choose an available art style.';
    if (step === 2 && state.imageLoading) return 'Please wait for your photos to finish opening.';
    if (step === 2 && (!state.photos.length || state.photos.length > 10)) return 'Add between 1 and 10 photos.';
    if (step === 2 && state.artworkText.trim() && !textPositions.has(state.artworkPosition)) return 'Choose where to place the text in your artwork.';
    if (step === 3 && (!Number.isInteger(state.subjects) || !subjectValues.includes(state.subjects))) return 'Choose an available whole number of subjects.';
    if (step === 4 && (!$('[data-email]').checkValidity() || !state.email)) return 'Enter a valid email address.';
    if (step === 5 && !availableVariants().some(v => v.options[sizeIndex] === state.size)) return 'Choose an available size for this number of subjects.';
    if (step === 6 && (!state.variant || !state.variant.available)) return 'Choose an available frame for this size.';
    return '';
  }
  const stepNames = ['Style','Photos','People','Email','Size','Frame','Review'];
  function firstInvalid(until) { for (let step=1;step<=until;step++) { const message=validateStep(step); if (message) return {step,message}; } return null; }
  function restoreEditor() {
    if (!editing) return;
    scrollVersion++;
    const panel = panels.get(editing); anchors.get(editing).after(panel); panel.hidden = true;
    delete panels.get(2).dataset.editField;
    panels.get(2).querySelector('h2').textContent = photoHeading;
    if (editSnapshot) editSnapshot.photos.filter(photo => !state.photos.includes(photo)).forEach(photo => URL.revokeObjectURL(photo.url));
    editSnapshot = null;
    errorAnchor.after(error);
    editing = null; $('[data-review-editor]').hidden = true;
    panels.get(7).append($('[data-review-editor]'));
    $$('[data-edit-step]').forEach(button => { button.setAttribute('aria-expanded','false'); button.textContent = button.dataset.editLabel; button.setAttribute('aria-label',button.dataset.editAria); });
    $('[data-review-editor]').append($('[data-review-cancel]')); $('[data-review-cancel]').hidden = true;
    $$('[data-confirm],[data-checkout],[data-inline-submit]').forEach(button => { button.disabled = state.busy || uncertain || !!firstInvalid(6); });
  }
  function cancelEditor() {
    if (!editSnapshot || state.imageLoading) return;
    state.photos.filter(photo => !editSnapshot.photos.includes(photo)).forEach(photo => URL.revokeObjectURL(photo.url));
    Object.assign(state, editSnapshot); state.photos = [...editSnapshot.photos];
    $('[data-email]').value = state.email; $('[data-notes]').value = state.notes;
    $('[data-notes-count]').textContent = state.notes.length;
    $('[data-artwork-text]').value = state.artworkText; $('[data-subjects]').value = String(state.subjects);
    selectStyle(state.styleId); syncTextPosition(); changeCount(state.subjects); renderPhotos();
    restoreEditor(); setError(''); editTrigger?.focus({preventScroll:true});
  }
  function openEditor(step, trigger) {
    if (state.busy || state.transitioning || state.imageLoading || uncertain || !panels.has(step) || step === 7) return;
    if (editing) cancelEditor();
    editing = step; editTrigger = trigger || $('[data-edit-step="' + step + '"]');
    if (step === 2) {
      const field = trigger?.dataset.editField || (!state.photos.length ? 'photos' : 'text');
      panels.get(2).dataset.editField = field;
      panels.get(2).querySelector('h2').textContent = {photos:'Edit photos',notes:'Changes requested',text:'Text on artwork'}[field];
    }
    editSnapshot = Object.fromEntries(['email','artworkText','artworkPosition','subjects','notes','style','styleId','size','frame','frameGroup','variant'].map(key => [key,state[key]]));
    editSnapshot.photos = [...state.photos];
    const editor = $('[data-review-editor]'); editor.hidden = false;
    const row = editTrigger?.closest('.fm-builder__review-summary dl > div');
    if (row) {
      const slot = row.querySelector('[data-review-slot]') || document.createElement('dd');
      slot.dataset.reviewSlot = ''; row.append(slot); slot.append(editor);
    } else editTrigger?.after(editor);
    $('[data-review-editor-content]').append(panels.get(step)); panels.get(step).hidden = false;
    $('[data-review-editor-content]').after(error);
    $$('[data-confirm],[data-checkout],[data-inline-submit]').forEach(button => { button.disabled = true; });
    $$('[data-edit-step]').forEach(button => button.setAttribute('aria-expanded',String(button === editTrigger)));
    editTrigger.textContent = 'Update'; editTrigger.setAttribute('aria-label','Update ' + editTrigger.dataset.editAria.replace(/^Edit\s*/i,''));
    editTrigger.after($('[data-review-cancel]')); $('[data-review-cancel]').hidden = false;
    setError('');
    scrollToEditor();
  }
  function showStep(step, focus=true) {
    restoreEditor(); state.step = Math.max(1,Math.min(7,step));
    panels.forEach((panel,n) => { panel.hidden = n !== state.step; });
    $$('[data-step-nav]').forEach(button => {
      const n = Number(button.dataset.stepNav); button.disabled = !!firstInvalid(n-1);
      button.classList.toggle('is-active',n === state.step);
      if (n === state.step) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
    });
    $('[data-step-status]').textContent = 'Step ' + state.step + ' of 7 · ' + stepNames[state.step-1];
    $('[data-back]').hidden = state.step === 1;
    $('[data-next]').hidden = $('[data-inline-continue]').hidden = state.step === 7;
    $('[data-confirm]').hidden = $('[data-checkout]').hidden = state.step !== 7;
    $('[data-review-actions]').hidden = state.step !== 7;
    root.classList.toggle('is-review',state.step === 7); refreshReview();
    if (focus) { const panel=panels.get(state.step); panel.querySelector('h2').focus({preventScroll:true}); panel.scrollIntoView({behavior:'instant',block:'start'}); }
  }
  function handleInvalid(invalid) {
    if (state.step === 7) openEditor(invalid.step); else showStep(invalid.step);
    setError(invalid.message); error.focus({preventScroll:true});
  }
  async function goTo(step) {
    if (state.busy || state.transitioning || uncertain) return;
    if (editing) { setError('Save or cancel your changes before leaving this editor.'); return; }
    const invalid = firstInvalid(step-1);
    if (invalid) { handleInvalid(invalid); return; }
    setError(''); showStep(step);
  }
  $('[data-next]').addEventListener('click',() => goTo(state.step+1));
  $('[data-inline-next]').addEventListener('click',() => goTo(state.step+1));
  $('[data-back]').addEventListener('click',() => goTo(state.step-1));
  $$('[data-step-nav]').forEach(button => button.addEventListener('click',() => goTo(Number(button.dataset.stepNav))));
  $$('[data-edit-step]').forEach(button => {
    button.dataset.editLabel = button.textContent; button.dataset.editAria = button.getAttribute('aria-label') || button.textContent;
    button.setAttribute('aria-expanded','false');
    button.addEventListener('click',() => editing && button === editTrigger ? saveEditor() : openEditor(Number(button.dataset.editStep),button));
  });
  function saveEditor() {
    if (!editing || state.imageLoading || state.busy) return;
    const field = panels.get(2).dataset.editField;
    const message = editing === 2 && field === 'notes' ? '' : validateStep(editing);
    if (message) { setError(message); error.focus({preventScroll:true}); return; }
    restoreEditor(); refreshReview(); setError(''); editTrigger?.focus({preventScroll:true});
    const invalid = firstInvalid(6);
    if (invalid) { openEditor(invalid.step); setError('Your changes require an updated selection. ' + invalid.message); }
  }
  $('[data-review-done]').addEventListener('click',saveEditor);
  $('[data-review-cancel]').addEventListener('click',cancelEditor);
  function fingerprint() { return JSON.stringify([state.photos.map(photo => photo.url),state.subjects,state.variant?.id,state.styleId,state.email,state.notes,state.artworkText,state.artworkPosition]); }
  syncTextPosition(); renderPhotos(); changeCount(1); showStep(1,false);
  const shopRoot = window.Shopify?.routes?.root || '/';
  async function getCart() { const response = await fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } }); if (!response.ok) throw new Error('Unable to check your cart.'); return response.json(); }
  async function updateCartUI(data, trigger) {
    const cart = await getCart(); cart.sections = data.sections || {};
    const pubsub = window.theme?.pubsub;
    if (pubsub?.PUB_SUB_EVENTS) pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fanmoment-customizer', productVariantId: String(state.variant.id), cart });
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show(trigger);
    else window.location.assign(shopRoot + 'cart');
  }
  async function submit(mode) {
    if (state.busy || state.transitioning || uncertain || editing) return;
    const invalid = firstInvalid(6);
    if (invalid) { handleInvalid(invalid); return; }
    state.busy = true; root.setAttribute('aria-busy', 'true'); setError('');
    const disabled = new Map();
    const panels = $$('[data-step-panel]'); panels.forEach(panel => { panel.inert = true; });
    root.querySelectorAll('button,input,textarea').forEach(element => { disabled.set(element, element.disabled); element.disabled = true; });
    const status = $('[data-submit-status]'); status.hidden = false; status.textContent = 'Preparing and uploading your artwork…';
    const recovery = $('[data-cart-recovery]'); recovery.hidden = true;
    const signature = fingerprint(); let data = null, requestSent = false, committed = false;
    const token = 'fm-' + (window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2));
    try {
      if (addedFingerprint === signature && addedKey) {
        const cart = await getCart();
        if (cart.items.some(item => item.key === addedKey)) { committed = true; data = { key: addedKey }; }
      }
      if (!committed) {
        const body = new FormData(), sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
        body.append('id', state.variant.id); body.append('quantity', '1');
        state.photos.forEach((photo, index) => {
          const key = index === 0 ? '_Original Image' : '_Original Image ' + (index + 1);
          body.append('properties[' + key + ']', photo.file, photo.file.name);
        });
        body.append('properties[_Photo Count]', String(state.photos.length));
        body.append('properties[Art Style]', state.style); body.append('properties[_Art Style ID]', state.styleId);
        body.append('properties[_Size]', state.size); body.append('properties[_Frame]', state.frame);
        body.append('properties[_Subject Count]', String(state.subjects));
        body.append('properties[_Contact Email]', state.email); body.append('properties[_Customization ID]', token);
        if (state.notes.trim()) body.append('properties[Customer Notes]', state.notes.trim());
        if (state.artworkText.trim()) {
          body.append('properties[Artwork Text]', state.artworkText.trim());
          body.append('properties[Artwork Text Position]', textPositions.get(state.artworkPosition));
        }
        body.set('sections', sections.slice(0, 5).join(',')); body.set('sections_url', window.location.pathname);
        requestSent = true;
        const response = await fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        if (!response.ok) {
          // 4xx is a definite rejection; an ambiguous server error must be reconciled.
          if (response.status < 500) requestSent = false;
          const failure = await response.json().catch(() => ({})); throw new Error(failure.description || 'Unable to add your artwork.');
        }
        data = await response.json(); committed = true;
        addedFingerprint = signature; addedKey = data.key;
      }
      if (lifecycle.signal.aborted || !root.isConnected) return;
      status.textContent = mode === 'checkout' ? 'Artwork saved. Opening secure checkout…' : 'Your custom artwork has been added to cart.';
      if (mode === 'checkout') { window.location.assign(shopRoot + 'checkout'); return; }
      try { await updateCartUI(data, $('[data-confirm]')); } catch (_) { recovery.hidden = false; status.textContent = 'Added successfully. Open your cart to continue.'; }
    } catch (err) {
      if (requestSent && !committed) {
        // Never blindly retry an upload that may have already added a line item.
        const cart = await getCart().catch(() => null);
        const item = cart?.items?.find(line => line.properties?.['_Customization ID'] === token);
        if (item) { addedFingerprint = signature; addedKey = item.key; committed = true; status.textContent = 'Your artwork is in your cart. Open the cart to continue.'; }
        else { uncertain = true; status.textContent = 'The upload result could not be confirmed. Check your cart before trying again.'; }
        recovery.hidden = false;
      } else { status.hidden = true; setError(err.message || 'Unable to add your artwork. Please try again.'); error.focus(); }
    } finally {
      state.busy = false; root.removeAttribute('aria-busy');
      panels.forEach(panel => { panel.inert = false; });
      disabled.forEach((value, element) => { element.disabled = value; });
      if (uncertain) root.querySelectorAll('button,input,textarea').forEach(element => { element.disabled = true; });
    }
  }
  $('[data-confirm]').addEventListener('click', () => submit('cart'));
  $('[data-checkout]').addEventListener('click', () => submit('checkout'));
  $$('[data-inline-submit]').forEach(button => button.addEventListener('click',() => submit(button.dataset.inlineSubmit)));
  }
  function mount(scope) { scope.querySelectorAll("[data-fm-builder]").forEach(initialize); }
  window.FanMomentSevenStep = { mount };
  mount(document);
  document.addEventListener("shopify:section:load", event => mount(event.target));
  document.addEventListener("shopify:section:unload", event => event.target.querySelectorAll("[data-fm-builder]").forEach(root => root.fmDestroy?.()));
})();
